define('OutSystems/ClientRuntime/modules/Database/Metadata/MetadataTableInfo',["require", "exports", "../AutoNumber", "../DBDataType", "../TableInfoUtils"], function (require, exports, AutoNumber_1, DBDataType_1, TableInfoUtils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var METADATA_TABLE_INFO = {
        tableName: TableInfoUtils_1.METADATA_TABLE_NAME,
        idIsAutoNumber: AutoNumber_1.default.No,
        attributes: [
            { name: "Key", columnName: "KEY", type: DBDataType_1.default.TEXT, isPrimaryKey: true },
            { name: "ModuleKey", columnName: "MODULEKEY", type: DBDataType_1.default.TEXT, isPrimaryKey: true },
            { name: "UpgradeStatus", columnName: "UPGRADESTATUS", type: DBDataType_1.default.INTEGER },
            { name: "Name", columnName: "NAME", type: DBDataType_1.default.TEXT },
            { name: "TableName", columnName: "TABLENAME", type: DBDataType_1.default.TEXT },
            { name: "Hash", columnName: "HASH", type: DBDataType_1.default.TEXT },
            { name: "ExtraInfo", columnName: "EXTRAINFO", type: DBDataType_1.default.TEXT },
        ],
    };
    exports.default = METADATA_TABLE_INFO;
});
//# sourceMappingURL=MetadataTableInfo.js.map;
